<div class="wrapper">
  <div
    #tableBlock
    class="notification">
    <div class="page-head">
      <div class="page-head__left">
        <button
          *ngIf="notificationList.length > 1"
          (click)="readAllNotifications()"
          class="btn btn-accent-filter icon">
          <img
            src="assets/img/notification-read-all.svg"
            alt="icon"
            class="icon-button" />
          {{ "NOTIFICATION_PAGE.READ_ALL" | translate }}
        </button>
        <button
          *ngIf="notificationList.length > 1"
          (click)="openDeleteAllDialog()"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.64734 1.3501H9.02246C9.31526 1.35009 9.56709 1.35008 9.77535 1.36429C9.99439 1.37924 10.2123 1.41205 10.4272 1.50107C10.9134 1.70245 11.2993 2.08882 11.5005 2.5746C11.5895 2.78945 11.6224 3.00727 11.6373 3.22632C11.64 3.266 11.6422 3.30727 11.644 3.3501H13.6682C14.0272 3.3501 14.3182 3.64111 14.3182 4.0001C14.3182 4.35908 14.0272 4.6501 13.6682 4.6501H12.9849V11.894C12.9849 12.2452 12.9849 12.5472 12.9646 12.7959C12.9431 13.0581 12.8959 13.3176 12.7689 13.5669C12.5786 13.9402 12.2746 14.244 11.9016 14.4341C11.6523 14.5611 11.3929 14.6083 11.1307 14.6298C10.882 14.6501 10.58 14.6501 10.2288 14.6501H6.44102C6.08984 14.6501 5.78767 14.6501 5.5389 14.6298C5.27665 14.6084 5.01705 14.5611 4.76767 14.4341C4.39391 14.2436 4.09093 13.9395 3.90107 13.5669C3.77395 13.3174 3.72668 13.0578 3.70522 12.7953C3.68487 12.5463 3.68488 12.2438 3.6849 11.892L3.6849 4.6501H3.00156C2.64258 4.6501 2.35156 4.35908 2.35156 4.0001C2.35156 3.64111 2.64258 3.3501 3.00156 3.3501H5.02575C5.02753 3.30729 5.02972 3.26604 5.03242 3.22638C5.04737 3.00735 5.08019 2.78949 5.1692 2.5746C5.37038 2.08891 5.75614 1.70249 6.2424 1.50107C6.45734 1.41204 6.67532 1.37923 6.89437 1.36429C7.10267 1.35008 7.35453 1.35009 7.64734 1.3501ZM6.32722 3.3501H10.3425C10.3419 3.33811 10.3411 3.32641 10.3404 3.31495C10.3299 3.16219 10.312 3.10226 10.2995 3.07208C10.23 2.90445 10.097 2.77139 9.92973 2.70211C9.89962 2.68964 9.8397 2.67171 9.68686 2.66128C9.52817 2.65045 9.32108 2.6501 9.00156 2.6501H7.66823C7.34871 2.6501 7.14157 2.65045 6.98284 2.66128C6.82992 2.67171 6.76998 2.68965 6.73989 2.70211C6.57274 2.77135 6.43972 2.90436 6.37024 3.07208C6.35776 3.10222 6.33983 3.16211 6.32941 3.31489C6.32862 3.32636 6.3279 3.33809 6.32722 3.3501ZM4.9849 4.6501V11.8668C4.9849 12.2509 4.9854 12.4998 5.0009 12.6894C5.01578 12.8714 5.04116 12.941 5.05937 12.9767C5.12518 13.1059 5.22984 13.2105 5.35785 13.2758C5.39341 13.2939 5.46287 13.3192 5.64478 13.3341C5.83424 13.3496 6.08281 13.3501 6.46617 13.3501H10.2036C10.587 13.3501 10.8354 13.3496 11.0247 13.3341C11.2064 13.3193 11.2758 13.2939 11.3114 13.2758C11.4401 13.2102 11.5451 13.1052 11.6106 12.9767C11.6287 12.9411 11.6541 12.8717 11.6689 12.69C11.6844 12.5006 11.6849 12.2522 11.6849 11.8688V4.6501H4.9849ZM7.00156 6.01677C7.36055 6.01677 7.65156 6.30778 7.65156 6.66677V11.3334C7.65156 11.6924 7.36055 11.9834 7.00156 11.9834C6.64258 11.9834 6.35156 11.6924 6.35156 11.3334V6.66677C6.35156 6.30778 6.64258 6.01677 7.00156 6.01677ZM9.66823 6.01677C10.0272 6.01677 10.3182 6.30778 10.3182 6.66677V11.3334C10.3182 11.6924 10.0272 11.9834 9.66823 11.9834C9.30924 11.9834 9.01823 11.6924 9.01823 11.3334V6.66677C9.01823 6.30778 9.30924 6.01677 9.66823 6.01677Z" />
          </svg>
          {{ "NOTIFICATION_PAGE.DELETE_ALL" | translate }}
        </button>
      </div>
      <div class="page-head__right">
        <app-filter-button
          [isOpenFilter]="isOpenFilter"
          [isEnableUpload]="false"
          (toggleFilterEvent)="toggleFilter($event)">
        </app-filter-button>
      </div>
    </div>

    <div class="payment-page__filter">
      <app-filter-block
        [additional]="filterAdditional"
        [(isOpenFilter)]="isOpenFilter">
        <app-notification-page-filter
          [filterStatuses]="filterStatuses"
          [priorityStatuses]="priorityStatuses">
        </app-notification-page-filter>
      </app-filter-block>
    </div>

    <div class="wrapper">
      <div
        #notificationBlock
        class="notification__block">
        <div class="notification__menu">
          <ul class="notification__block-tab">
            <li
              [class.active]="tabSelect === 'all'"
              (click)="selectTab('all')"
              class="item">
              {{ "NOTIFICATION_PAGE.ALL" | translate }}
            </li>
            <li
              [class.active]="tabSelect === 'for-me'"
              (click)="selectTab('for-me')"
              class="item">
              {{ "NOTIFICATION_PAGE.FOR_ME" | translate }}
            </li>
            <li
              [class.active]="tabSelect === 'common'"
              (click)="selectTab('common')"
              class="item">
              {{ "NOTIFICATION_PAGE.COMMON" | translate }}
            </li>
          </ul>

          <button
            (click)="toggleSort()"
            [class.active]="sortState"
            class="notification__sort-bth"></button>
        </div>

        <div
          (scroll)="onScroll($event)"
          #tableBlock
          class="scroll-block">
          <div #tableBody>
            <div class="notification__block-content">
              <div class="item">
                <app-notification-item
                  *ngFor="let item of notificationList"
                  (readNotificaitonEvent)="readNotification($event)"
                  [isItemSelected]="selectedNotification === item"
                  [item]="item"
                  (deleteItemEvent)="openDeleteItemDialog($event)">
                </app-notification-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr *ngIf="selectedNotification" />

      <div
        *ngIf="selectedNotification"
        class="info-block">
        <button class="btn-icon readed">
          <img
            src="assets/img/read-icon.svg"
            class="btn-icon__image" />
          <span> {{ "NOTIFICATION_PAGE.READED" | translate }}</span>
        </button>

        <p class="notification-title">
          {{ selectedNotification.notification_name }}
        </p>

        <p class="notification-text">
          {{ selectedNotification.notification_text }}
        </p>

        <div class="notification-footer">
          <div class="date-container">
            <img
              class="date-icon"
              src="assets/img/calendar.svg"
              alt="" />
            <p class="notification-item__date">
              {{ selectedNotification.creation_date }}
            </p>
          </div>

          <div class="relation-container">
            <ng-container *ngIf="selectedNotification.notification_relation === 3">
              <img src="assets/img/users-icon.svg" />
              <span> {{ "NOTIFICATION_PAGE.COMMON" | translate }}</span>
            </ng-container>
            <ng-container *ngIf="selectedNotification.notification_relation === 2">
              <img src="assets/img/user.svg" />
              <span> {{ "NOTIFICATION_PAGE.FOR_ME" | translate }}</span>
            </ng-container>
          </div>
        </div>

        <button
          (click)="openDeleteItemDialog(selectedNotification.id)"
          class="btn btn-light-filter icon">
          <svg
            class="icon-button"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.64734 1.3501H9.02246C9.31526 1.35009 9.56709 1.35008 9.77535 1.36429C9.99439 1.37924 10.2123 1.41205 10.4272 1.50107C10.9134 1.70245 11.2993 2.08882 11.5005 2.5746C11.5895 2.78945 11.6224 3.00727 11.6373 3.22632C11.64 3.266 11.6422 3.30727 11.644 3.3501H13.6682C14.0272 3.3501 14.3182 3.64111 14.3182 4.0001C14.3182 4.35908 14.0272 4.6501 13.6682 4.6501H12.9849V11.894C12.9849 12.2452 12.9849 12.5472 12.9646 12.7959C12.9431 13.0581 12.8959 13.3176 12.7689 13.5669C12.5786 13.9402 12.2746 14.244 11.9016 14.4341C11.6523 14.5611 11.3929 14.6083 11.1307 14.6298C10.882 14.6501 10.58 14.6501 10.2288 14.6501H6.44102C6.08984 14.6501 5.78767 14.6501 5.5389 14.6298C5.27665 14.6084 5.01705 14.5611 4.76767 14.4341C4.39391 14.2436 4.09093 13.9395 3.90107 13.5669C3.77395 13.3174 3.72668 13.0578 3.70522 12.7953C3.68487 12.5463 3.68488 12.2438 3.6849 11.892L3.6849 4.6501H3.00156C2.64258 4.6501 2.35156 4.35908 2.35156 4.0001C2.35156 3.64111 2.64258 3.3501 3.00156 3.3501H5.02575C5.02753 3.30729 5.02972 3.26604 5.03242 3.22638C5.04737 3.00735 5.08019 2.78949 5.1692 2.5746C5.37038 2.08891 5.75614 1.70249 6.2424 1.50107C6.45734 1.41204 6.67532 1.37923 6.89437 1.36429C7.10267 1.35008 7.35453 1.35009 7.64734 1.3501ZM6.32722 3.3501H10.3425C10.3419 3.33811 10.3411 3.32641 10.3404 3.31495C10.3299 3.16219 10.312 3.10226 10.2995 3.07208C10.23 2.90445 10.097 2.77139 9.92973 2.70211C9.89962 2.68964 9.8397 2.67171 9.68686 2.66128C9.52817 2.65045 9.32108 2.6501 9.00156 2.6501H7.66823C7.34871 2.6501 7.14157 2.65045 6.98284 2.66128C6.82992 2.67171 6.76998 2.68965 6.73989 2.70211C6.57274 2.77135 6.43972 2.90436 6.37024 3.07208C6.35776 3.10222 6.33983 3.16211 6.32941 3.31489C6.32862 3.32636 6.3279 3.33809 6.32722 3.3501ZM4.9849 4.6501V11.8668C4.9849 12.2509 4.9854 12.4998 5.0009 12.6894C5.01578 12.8714 5.04116 12.941 5.05937 12.9767C5.12518 13.1059 5.22984 13.2105 5.35785 13.2758C5.39341 13.2939 5.46287 13.3192 5.64478 13.3341C5.83424 13.3496 6.08281 13.3501 6.46617 13.3501H10.2036C10.587 13.3501 10.8354 13.3496 11.0247 13.3341C11.2064 13.3193 11.2758 13.2939 11.3114 13.2758C11.4401 13.2102 11.5451 13.1052 11.6106 12.9767C11.6287 12.9411 11.6541 12.8717 11.6689 12.69C11.6844 12.5006 11.6849 12.2522 11.6849 11.8688V4.6501H4.9849ZM7.00156 6.01677C7.36055 6.01677 7.65156 6.30778 7.65156 6.66677V11.3334C7.65156 11.6924 7.36055 11.9834 7.00156 11.9834C6.64258 11.9834 6.35156 11.6924 6.35156 11.3334V6.66677C6.35156 6.30778 6.64258 6.01677 7.00156 6.01677ZM9.66823 6.01677C10.0272 6.01677 10.3182 6.30778 10.3182 6.66677V11.3334C10.3182 11.6924 10.0272 11.9834 9.66823 11.9834C9.30924 11.9834 9.01823 11.6924 9.01823 11.3334V6.66677C9.01823 6.30778 9.30924 6.01677 9.66823 6.01677Z" />
          </svg>
          {{ "NOTIFICATION_PAGE.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal [isOpenModal]="isOpenDeleteNotification">
  <app-delete-item-notification-dialog
    (deleteItemNotification)="deleteItemNotification($event)"
    [notificationId]="notificationId">
  </app-delete-item-notification-dialog>
</app-modal>

<app-modal [isOpenModal]="isOpenDeleteAllNotification">
  <app-delete-all-notification-dialog (deleteAllNotification)="deleteAllNotification()"> </app-delete-all-notification-dialog>
</app-modal>
